import React from "react";

const Details = () => {
  return (
    <div className=" md:h-[650px] overflow-y-scroll w-full">
      <div className="md:flex p-5">
        <img
          class="w-20 h-20 rounded mr-2"
          src="https://flowbite.com/docs/images/people/profile-picture-5.jpg"
          alt="Default avatar"
        />
        <div>
          <h3 className="text-primary-600 text-4xl font-extrabold mb-3">
            John Doe |{" "}
            <span className="text-primary-300 text-2xl font-semibold">
              sales
            </span>
          </h3>
          <p className="flex text-amber-800">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              fill="currentColor"
              className="w-6 h-6"
            >
              <path
                fillRule="evenodd"
                d="M7.5 5.25a3 3 0 013-3h3a3 3 0 013 3v.205c.933.085 1.857.197 2.774.334 1.454.218 2.476 1.483 2.476 2.917v3.033c0 1.211-.734 2.352-1.936 2.752A24.726 24.726 0 0112 15.75c-2.73 0-5.357-.442-7.814-1.259-1.202-.4-1.936-1.541-1.936-2.752V8.706c0-1.434 1.022-2.7 2.476-2.917A48.814 48.814 0 017.5 5.455V5.25zm7.5 0v.09a49.488 49.488 0 00-6 0v-.09a1.5 1.5 0 011.5-1.5h3a1.5 1.5 0 011.5 1.5zm-3 8.25a.75.75 0 100-1.5.75.75 0 000 1.5z"
                clipRule="evenodd"
              />
              <path d="M3 18.4v-2.796a4.3 4.3 0 00.713.31A26.226 26.226 0 0012 17.25c2.892 0 5.68-.468 8.287-1.335.252-.084.49-.189.713-.311V18.4c0 1.452-1.047 2.728-2.523 2.923-2.12.282-4.282.427-6.477.427a49.19 49.19 0 01-6.477-.427C4.047 21.128 3 19.852 3 18.4z" />
            </svg>
            Full Stack Developer
          </p>
          <p className="flex text-rose-500">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              fill="currentColor"
              className="w-6 h-6"
            >
              <path
                fillRule="evenodd"
                d="M11.54 22.351l.07.04.028.016a.76.76 0 00.723 0l.028-.015.071-.041a16.975 16.975 0 001.144-.742 19.58 19.58 0 002.683-2.282c1.944-1.99 3.963-4.98 3.963-8.827a8.25 8.25 0 00-16.5 0c0 3.846 2.02 6.837 3.963 8.827a19.58 19.58 0 002.682 2.282 16.975 16.975 0 001.145.742zM12 13.5a3 3 0 100-6 3 3 0 000 6z"
                clipRule="evenodd"
              />
            </svg>
            Somewhere, on Earth, in SOL
          </p>
          <p className="flex text-yellow-400">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              fill="currentColor"
              className="w-6 h-6"
            >
              <path
                fillRule="evenodd"
                d="M7.5 6a4.5 4.5 0 119 0 4.5 4.5 0 01-9 0zM3.751 20.105a8.25 8.25 0 0116.498 0 .75.75 0 01-.437.695A18.683 18.683 0 0112 22.5c-2.786 0-5.433-.608-7.812-1.7a.75.75 0 01-.437-.695z"
                clipRule="evenodd"
              />
            </svg>
            Mr. Jones Tester
          </p>
          <p className="mt-3 text-lg">
            Lorem ipsum dolor sit amet consectetur adipisicing elit. Esse
            voluptatum impedit officia debitis repudiandae. Et nulla ad
            reiciendis suscipit rem, cumque architecto porro, iusto delectus
            neque, iure at temporibus esse.
          </p>
        </div>
      </div>
      <hr />
      <div className="p-5">
        <h3 className="text-2xl font-bold mb-4">Addresses and Contact</h3>
        <p><span className="font-bold text-xl text-orange-500 mb-5">Main address -</span> somewhere, on Earth, Sol</p>
        <p><span className="font-bold text-xl text-orange-500 mb-5">Email -</span> John@doe.com</p>
        <p><span className="font-bold text-xl text-orange-500 mb-5">Phone -</span> +001234567890</p>
        <p><span className="font-bold text-xl text-orange-500 mb-5">Slack -</span> @john_doe</p>
        <p><span className="font-bold text-xl text-orange-500 mb-5">Emergency Contact -</span> +001234567890</p>
      </div>
      <hr />
      <div className="p-5">
        <h3 className="text-2xl font-bold mb-4">Experience</h3>
        <div className="border-2 border-gray-400 hover:border-primary-600 p-4 rounded-xl mb-5 shadow-xl">
            <h3 className="text-2xl font-semibold mb-5">Project Blah Blah 1 <span className="text-primary-400">(current)</span></h3>
            <p className="text-gray-700">Lorem ipsum dolor sit amet consectetur adipisicing elit. Laborum consequuntur amet, pariatur tempore exercitationem sit minus suscipit sed, accusantium libero ut officia labore est magni eum a provident asperiores alias.</p>
        </div>
        <div className="border-2 border-gray-400 hover:border-primary-600 p-4 rounded-xl mb-5 shadow-xl">
            <h3 className="text-2xl font-semibold mb-5">Project Blah Blah 2</h3>
            <p className="text-gray-700">Lorem ipsum dolor sit amet consectetur adipisicing elit. Laborum consequuntur amet, pariatur tempore exercitationem sit minus suscipit sed, accusantium libero ut officia labore est magni eum a provident asperiores alias.</p>
        </div>
        <div className="border-2 border-gray-400 hover:border-primary-600 p-4 rounded-xl mb-5 shadow-xl">
            <h3 className="text-2xl font-semibold mb-5">Project Blah Blah 3</h3>
            <p className="text-gray-700">Lorem ipsum dolor sit amet consectetur adipisicing elit. Laborum consequuntur amet, pariatur tempore exercitationem sit minus suscipit sed, accusantium libero ut officia labore est magni eum a provident asperiores alias.</p>
        </div>
        <div className="border-2 border-gray-400 hover:border-primary-600 p-4 rounded-xl mb-5 shadow-xl">
            <h3 className="text-2xl font-semibold mb-5">Project Blah Blah 4</h3>
            <p className="text-gray-700">Lorem ipsum dolor sit amet consectetur adipisicing elit. Laborum consequuntur amet, pariatur tempore exercitationem sit minus suscipit sed, accusantium libero ut officia labore est magni eum a provident asperiores alias.</p>
        </div>
      </div>
    </div>
  );
};

export default Details;
